import React,{useState, useEffect,useContext} from 'react';

import {
  Alert,
  Container,
  ProgressBar
} from 'react-bootstrap';

import UserContext from '../contexts/UserContext';

import {useParams} from "react-router-dom";

import Utils from './../Utils';
import { MessageModal } from '../components/MessageModal';
import {Step1,Step2, Step3} from './BuilderSteps';

import axios from 'axios';
import _ from 'lodash';

const Builder = (props) => {  

  const { recid,isweb } = useParams();
  const {userData, setUCStepData, deleteDraft, saveDraft, thirdPUserData} = useContext(UserContext);
  const [message, setMessage] = useState(false);
  const [loading, setLoading] = useState(recid==='lib' ? 'Fetching library details' : (parseInt(recid) > 0 ? "Fetching scorm details" : false));
  const [stepData, setStepData] = useState(loading ? {} : _.get(userData, `stepData${userData.id}`, {step:1}));

  const loadExistingScorm = () => {

    console.log(thirdPUserData.from)
    setLoading('Fetching your SVASU details..');
    axios.get(Utils.apiUrl(`scorm/load?id=${recid}`),Utils.apiHeaders()).then(res => {    
      setLoading(false);
      if(res.data.success){              
        const d = JSON.parse(res.data.data.data);
        const editData = {
          ...d.scorm,
          step: 3,           
          slides: d.slides, 
          folder: d.folder,
          scorm_id: parseInt(recid)};      
        setStepData(editData);
        let stepData1 = `stepData${userData.id}`;
        Utils.setUserData({...userData, stepData1 : editData});
        Utils.saveUserData(userData,editData);
        if(Utils.getCourseType() === 'clone'){
          Utils.setCourseType(false);
        }else{
          Utils.setCourseType('scorm');
        }
      }else{
        window.alert(res.data.error);
        window.location.href = process.env.PUBLIC_URL + '/builder';
      }
    }).catch(err => {
      window.alert(JSON.stringify(err)); 
    });        
  }

  const loadExistingWeb = () => {

    setLoading('Fetching your web details..');
    axios.get(Utils.apiUrl(`web/load?id=${recid}`),Utils.apiHeaders()).then(res => {    
      setLoading(false);
      if(res.data.success){              
        const d = JSON.parse(res.data.data.data);
        const editData = {
          ...d.scorm,
          step: 3,           
          slides: d.slides, 
          folder: d.folder,
          scorm_id: parseInt(recid)};      
        setStepData(editData);
        let stepData1 = `stepData${userData.id}`;
        Utils.setUserData({...userData, stepData1 : editData});
        Utils.saveUserData(userData,editData);
        if(Utils.getCourseType() === 'clone'){
          Utils.setCourseType(false);
        }else{
          Utils.setCourseType('web');
        }
      }else{
        window.alert(res.data.error);
        window.location.href = process.env.PUBLIC_URL + '/builder';
      }
    }).catch(err => {
      window.alert(JSON.stringify(err)); 
    });        
  }

  const loadLibrary = (libid) => {

    setLoading('Fetching library details..');
    axios.get(Utils.apiUrl(`library/unpack?id=${libid}`),Utils.apiHeaders()).then(res => {    
      setLoading(false);
      if(res.data.success){
        const d = JSON.parse(res.data.data.data);
        const editData = {
          ...d.scorm,
          step: 3,           
          slides: d.slides, 
          folder: d.folder,
          scorm_id: parseInt(recid)};      
        setStepData(editData);
        let stepData1 = `stepData${userData.id}`;
        Utils.setUserData({...userData, stepData1 : editData});
        Utils.saveUserData(userData,editData);
        Utils.setCourseType('scorm');
      }else{
        window.alert(res.data.error);
        window.location.href = process.env.PUBLIC_URL + '/builder';
      }
    }).catch(err => {
      window.alert(JSON.stringify(err)); 
    });        
  }

  useEffect(()=>{    
    if(!Utils.isLoggedIn()){      
      window.location.href= process.env.PUBLIC_URL + '/login';
    }else if(recid==='lib'){
      loadLibrary(parseInt(isweb));
    }
    else if(recid > 0){
      if(isweb === '1'){
        loadExistingWeb();
      }else{
        loadExistingScorm();
      }
    }else{
      Utils.setCourseType(false);
    }
  },[]);

  useEffect(()=> {
    if(! (parseInt(recid)) > 0){
      var getUser =  Utils.getUserData();    
      Utils.saveUserData(getUser,  stepData);      
    }   
    setUCStepData(stepData); 
  }, [stepData]);

  const goPrev = () => {
    if(userData.draft === 'edit'){
      if(!(window.confirm("Leaving this page will overwrite your existing draft.\nDo you want to continue?"))){
        return;
      }
      else{
        deleteDraft((success, msg) => {console.log(msg);});
        saveDraft('builder', (success, msg) => {
          if(success){
            setMessage([success ?  'info' : 'error' , msg]);  
            window.location.href = process.env.PUBLIC_URL + '/builder';
          }
        })
      }  
    }
    else{
      if(!(window.confirm("Do you want to leave SVASU? \nYour SVASU details will no longer be available."))){
        return;
      }
      else{
        if(parseInt(recid) > 0){
          Utils.setCourseType(false);
          window.location.href=process.env.PUBLIC_URL + '/scorms';
          return;
        }
        if(recid === 'lib'){
          window.location.href = process.env.PUBLIC_URL + '/builder';
        }  
      }
      Utils.setCourseType(false);     
      let udata = Utils.getUserData();
      udata[`stepData${udata.id}`] = {step : 1};
      localStorage.setItem(process.env.REACT_APP_APPNAME + '-userData',JSON.stringify(udata));
      setStepData({step : 1});
    } 
  }

  const goNext = () => {    
    setStepData({
      ...stepData,
      step: stepData.step+1
    });
  }

  if(!Utils.isLoggedIn()){       
    return <Alert variant="danger" className="p-4">You are not authorized to view this page</Alert>;
  }else{   
    return <Container>
      {loading!==false && <div className="text-center p-2 m-2"><Alert> {loading}<br /><ProgressBar className="mt-2" animated variant="primary" now={100} /></Alert></div>}
      {stepData.step > 1 && <div className="mb-3"><span className="clickable" onClick={goPrev} title="Back to Previous Screen"><img src={`${process.env.PUBLIC_URL}/images/back_arrow.png`} alt="Back" /> Back</span></div>}
      {loading===false && stepData.step===1 && <Step1 onContinue={(mode,sprops) => setStepData({...stepData, step: 2, mode: mode, sprops: sprops})} />}
      {loading===false && stepData.step===2 && <Step2 stepData={stepData} onUpload={setStepData} onNext={goNext} />}
      {loading===false && stepData.step===3 && <Step3 stepData={stepData} onSlideSave={setStepData}/>}
    </Container>;
  }
};

export default Builder;